<template>
  <div class="content widfix">
    <form
      id="scAll"
    >
      <div id="sc-all-realgrid" style="width: 1205px; height: 400px"></div>

      <div id="layerPop">
        <win-layer-pop class="sc-pre-all-pop">
          <component
            v-if="scAllComponent"
            :is="scAllComponent"
            @close="closePopup"
            :parent-info="popupParams"
          />
        </win-layer-pop>
      </div>
    </form>
    <!-- [S] paging -->
    <div
      v-if="rstList.length > 0"
      class="paging"
    >
      <!-- <a
        class="btn start"
        @click.prevent="search(1, false)"
      >Start</a> -->
      <a
        class="btn prev"
        @click.prevent="search(pagination.prevPage, false)"
      >Prev</a>
      <a
        v-for="idx in pageNumberRange"
        :key="idx"
        :class="[idx === scAllParams.curPage ? 'on' : '']"
        href="#"
        @click.prevent="search(idx, false)"
      >{{ idx }}</a>
      <a
        class="btn next"
        @click.prevent="search(pagination.nextPage, false)"
      >Next</a>
      <!-- <a
        class="btn end"
        @click.prevent="search(pagination.pageCnt, false)"
      >End</a> -->
    </div>
    <!-- [E] paging -->
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil' // realgrid Component
import member from '@/api/rest/user/member'
import ESearchAddress from '@/components/common/ESearchAddress'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import DownloadPop from '@/pages/trans/popup/SpecialRfDgDownloadPop'
import DEXT5Upload from '@/components/DEXT5Upload'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import api from '@/api/services/auth'
import EDatePicker from '@/components/common/EDatePickerCustom'
import EInputNumber from '@/components/common/EInputNumber'
import JSZip from 'jszip' // 엑셀 다운로드용 JSZip Component
import schedule from '@/api/rest/schedule/schedule'
import { rootComputed, rootMethods } from '@/store/helpers'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'num', dataType: 'text' },
  { fieldName: 'scNo', dataType: 'text' },
  { fieldName: 'amndNo', dataType: 'text' },
  { fieldName: 'strDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' },
  { fieldName: 'endDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' },
  { fieldName: 'fmcOrgEnm', dataType: 'text' },
  { fieldName: 'stsCd', dataType: 'text' },
  { fieldName: 'preview', dataType: 'text' }
]

export const columns = [
  { name: 'num', fieldName: 'num', type: 'text', header: 'No.', editable: false, width: 20 },
  { name: 'scNo', fieldName: 'scNo', type: 'text', header: 'S/C No.', editable: false, width: 50 },
  { name: 'amndNo', fieldName: 'amndNo', type: 'text', header: 'Amendment', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'strDt', fieldName: 'strDt', type: 'text', header: 'Start Date', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'endDt', fieldName: 'endDt', type: 'text', header: 'End Date', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'stsCd', fieldName: 'stsCd', type: 'text', header: 'stsCd', editable: false, width: 50 },
  { name: 'fmcOrgEnm', fieldName: 'fmcOrgEnm', type: 'text', header: 'Shipper Name', editable: false, width: 50 },
  {
    name: 'preview',
    fieldName: 'preview',
    type: 'text',
    header: '',
    editable: false,
    width: 50,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = []
        const scNo = vmAppScAll.rstList[idx].scNo || ''
        const amndNo = vmAppScAll.rstList[idx].amndNo || ''

        html.push(`<button class="button blue sh" onclick="vmAppScAll.scPreviewPopCall('${scNo}', '${amndNo}')">Preview</button>`) //

        return html
      }
    }
  }

]

const gridLayout = [
  'num',
  'scNo',
  'amndNo',
  'fmcOrgEnm',
  'strDt',
  'endDt',
  'preview'
]

export default ({
  name: 'MyScInfoAll',
  components: {
    WinLayerPop,
    ESearchAddress,
    DownloadPop,
    DEXT5Upload,
    EBreadcrumbs,
    MyInfoDextUploader: () => import('@/pages/user/MyInfoDextUploader'),
    EDatePicker,
    EInputNumber,
    EDateRangePickerSimple: () => import('@/components/common/EDateRangePickerSimple'),
    'e-auto-complete-place': () => import('@/components/common/EAutoCompletePlace'),
    'sc-preview-pop': () => import('@/pages/schedule/popup/ScPreviewPop')
  },
  data () {
    return {
      uploadParam: [],
      selectFunc: null,
      showHelp: false,
      ctrList: [],
      userInfoList: [],

      scAllParams:
        {
          curPage: 1, // 현재 페이지
          pageSize: 10, // 한 페이지당 게시글 수
          searchKnd: 'all'
        },

        fileList: [],
        // 카테고리가 있는 경우
        fileOriginalName: '',

        scAllComponent: null,
        uploadParams: [],
        uploadFileInfo: [],
        dext5Idx: 0,
        isShowDext5: true,
        isShowDext5Pop: false,

        // 다국어 항목 변수
        isKor: true,

        // 영문입력 체크 변수
        valid: '',
        rstList: [],
        gridList: [],
        currentPage: '',
        totalPage: '',
        total: '',
        popupComponent: null,
        popupParams: {
            items: []
        },
        popupCallback: '',

        scPreviewList: [],
        pagination: {},
        isInit: false
    }
  },
  computed: {
    ...rootComputed,
    pageNumberRange: function () {
        return [...Array(this.pagination.pageNumberSize).keys()].map(i => i + this.pagination.startPage)
    }
  },
  async mounted () {
    console.log('mounted!')

    window.vmAppScAll = this

    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    const grid = createGrid('sc-all-realgrid', {
      fields,
      columns,
      layout: gridLayout,
      header: {
        heights: [40]
      },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'evenFill',
        syncGridHeight: true
      },
      stateBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      checkBar: {
        visible: false
      }
    })
    gridView = grid.gridView
    provider = grid.provider

    await this.search(1, true, this.scAllParams)
  },
  created () {
    // this.initInfo()

    // 다국어 항목 제어
    if (this.$i18n.locale !== 'ko-KR') {
      this.isKor = false
    }

    // console.log('this.loginInfo ::: === ', this.loginInfo)
  },
  methods: {
    async search (index, searchFlag, params) {
      console.log('search all @@ ')

      if (this.isInit && index < 1) {
        this.$ekmtcCommon.alertDefault(this.$t('js.common.002')) // 처음페이지입니다.
        return
      }
      if (this.isInit && this.pagination && index > this.pagination.pageCnt) {
        this.$ekmtcCommon.alertDefault(this.$t('js.common.001')) // 마지막페이지입니다.
        return
      }

      // !searchFlag(페이지 이동 시) 현재 페이지와 이동할 페이지 같다면
      if (!searchFlag && this.isInit && this.scAllParams.curPage === index) return

      if (this.$ekmtcCommon.isEmpty(params)) {
        this.scAllParams.curPage = index
      } else {
        params.curPage = index
        this.scAllParams = params
      }

      await schedule.getScPreviewList(this.scAllParams)
      .then(response => {
          const resp = response.data
          const scPreviewList = resp.scPreviewList
          const pagination = resp.pagination

          console.log('response @@@@ ', response)

          this.rstList = []
          this.pagination = pagination

          this.rstList = scPreviewList
          provider.setRows(this.rstList)

          if (!this.isInit) this.isInit = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    scPreviewPopCall (scNo, amndNo) {
      let params = {
        scNo, amndNo
      }

      let arrParams = []

      arrParams.push(params)

      this.openPopup('sc-preview-pop', arrParams)
    },
    openPopup (compNm, params) {
      console.log('openPopup @@@@ ', params)

      this.popupParams.items = params
      this.scAllComponent = compNm
      this.$ekmtcCommon.layerOpen('.sc-pre-all-pop')
    },
    closePopup () {
      this.scAllComponent = null
      this.popupCallback = ''
      this.$ekmtcCommon.layerClose('.sc-pre-all-pop')
    }
  }
})
</script>
<style scoped>
.popup_dim .layer_close {z-index: 2998 !important}
.popup_dim2 {z-index: 2999 !important}

.border-none {
  border : 0 !important;
}

table th, td {
    border : 0 !important;
    background: white;
}

table th, td {
    padding: 8px 0 0 10px !important;
    border : 0 !important;
    background: white;
}

.bul_list_sm li::before {
  content: none !important;
}

.input_calendar.mid, .input_calendar.mid input {
    width: 160px !important;
}

.tbl_icon.help {
    margin-bottom: 10px !important;
}

</style>
